import { SET_INVOICE_ARRAY, RESET_INVOICES } from "../../types";
import { InvoiceData } from "../../../models/Entregas";

export const setInvoices = (payload: InvoiceData[]) => ({
  type: SET_INVOICE_ARRAY,
  payload,
});

export const resetInvoices = () => ({
  type: RESET_INVOICES,
});
